import { render, staticRenderFns } from "./CreateModify.vue?vue&type=template&id=2108be0e"
import script from "./CreateModify.vue?vue&type=script&lang=js"
export * from "./CreateModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports